//core
import React, {useEffect, useState} from "react";
import {makeStyles} from "@mui/styles";
import {useTranslation} from "react-i18next";
import {format} from "date-fns";
import enLocale from "date-fns/locale/en-US";
import ruLocale from "date-fns/locale/ru";
import ukLocale from "date-fns/locale/uk";
import esLocale from "date-fns/locale/es";
import trLocale from "date-fns/locale/tr";
import koLocale from "date-fns/locale/ko";
import thLocale from "date-fns/locale/th";
import viLocale from "date-fns/locale/vi";
import idLocale from "date-fns/locale/id";

interface IDateTime {
  value: any;
}

type itemLocale = {
  locale: object,
  format: string,
}

const localeMap = {
  en: {
    locale: enLocale,
    format: 'MM/dd/yyyy'
  },
  ru: {
    locale: ruLocale,
    format: 'dd.MM.yyyy'
  },
  uk: {
    locale: ukLocale,
    format: 'dd.MM.yyyy'
  },
  es: {
    locale: esLocale,
    format: 'dd/MM/yyyy'
  },
  tr: {
    locale: trLocale,
    format: 'dd/MM/yyyy'
  },
  ko: {
    locale: koLocale,
    format: 'yyyy.MM.dd'
  },
	th: {
		locale: thLocale,
		format: 'dd/MM/yyyy'
	},
	vi: {
		locale: viLocale,
		format: 'dd/MM/yyyy'
	},
	id: {
		locale: idLocale,
		format: 'dd/MM/yyyy'
	},
};

const useStyles = makeStyles({
  text: {
    color: 'inherit'
  }
});

const DateTime = ({ value }: IDateTime) => {
  const styles = useStyles();
  const { i18n } = useTranslation();

  const [locale, setLocale] = useState<itemLocale>(localeMap.en);

  useEffect(() => {
    if (i18n.language === 'ru') {
      setLocale(localeMap.ru);
    }

    if (i18n.language === 'en') {
      setLocale(localeMap.en);
    }

    if (i18n.language === 'uk') {
      setLocale(localeMap.uk);
    }

    if (i18n.language === 'es') {
      setLocale(localeMap.es);
    }

    if (i18n.language === 'tr') {
      setLocale(localeMap.tr);
    }

    if (i18n.language === 'ko') {
      setLocale(localeMap.ko);
    }
		if (i18n.language === 'th') {
      setLocale(localeMap.th);
    }
		if (i18n.language === 'vi') {
      setLocale(localeMap.vi);
    }
		if (i18n.language === 'id') {
      setLocale(localeMap.id);
    }
  }, [i18n.language]);

  return (
    <span className={styles.text}>
      {
        !!value ? format(new Date(value), locale.format, {locale: locale.locale}) : '—'
      }
    </span>
  );
};

export default DateTime;
